import { useEffect, useRef, useState } from 'react';
import useSWR from 'swr';

import keycloakService from '../../keycloak_service';

import { sinatraOrigin } from '../../config';

const fetchFromSinatra = (queryParams) => {
  const [sinatraEndpoint, fetchOptions] = queryParams;
  return fetch(`${sinatraOrigin}/${sinatraEndpoint}`, fetchOptions).then(response => response.json())
}

// This hook augments the passed in comments with their authoring users, fetching those users
// from Keycloak (via the Sinatra app) if necessary.
const useUserDataFetch = () => {
  const errorTimeoutRef = useRef(null);
  const [errorMessage, setError] = useState(null);
  const [users, setUsers] = useState(null);

  const keycloakHeader = keycloakService.getAuthHeader();
  const hasKeycloakHeader = keycloakHeader?.length;
  const fetchOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: keycloakHeader,
    },
    body: JSON.stringify({}),
  };

  const {
    data,
    isLoading,
    error,
    mutate,
  } = useSWR(hasKeycloakHeader ? ['v1/api/users/query', fetchOptions] : null, fetchFromSinatra, {
    refreshInterval: 3000,
  })

  useEffect(() => {
    if (!data?.users) {
      return;
    }

    setUsers(Object.values(data.users));
  }, [data]);

  useEffect(() => {
    if (error) {
      errorTimeoutRef.current = setTimeout(() => {
        setError(error?.message);
      }, 1500);
    } else {
      clearTimeout(errorTimeoutRef.current);
      setError(null);
    }

    return () => {
      clearTimeout(errorTimeoutRef.current);
      setError(null);
    }
  }, [error]);

  return {
    loading: isLoading,
    error: errorMessage,
    data: users,
    refetch: mutate,
  }
};

export default useUserDataFetch;
